import axios from "axios"
import store from '@/store'
import router from "@/router"
import { Notification, MessageBox, Message, Loading } from 'element-ui'
const instance = axios.create({
  baseURL: 'https://yixue.cgwzjs.com',
  timeout: 5000,
})
instance.interceptors.request.use(function (config) {
  let token = localStorage.getItem("token")
  if (token) {
    config.headers.token = token
  }
  return config;
});
instance.interceptors.response.use(res => {
  console.log(router.app._route.meta)
  if(res.data.code==0){
     Message({
        message: res.data.msg,
        type: 'error'
      })
  }else if(res.data.code==2&&router.app._route.meta.requiresAuth){
    //  Message({
    //     message: res.data.msg,
    //     type: 'error'
    //   })
     store.commit("logout");
  }else{
    return res.data
  }
  
}, error => {
  return Promise.reject(new Error('faile'))
})

export default instance